import { ContentStateInterface } from '../../../../../../@types/types'

type ApiSearchDataPartial = {
  searchField1?: string
  searchField2?: string
  searchField3?: string
}
export const apiSearchDataToApi = (insertionData: ContentStateInterface): ApiSearchDataPartial => {
  const properties: (keyof ApiSearchDataPartial)[] = ['searchField1', 'searchField2', 'searchField3']
  return properties.reduce((acc, property) => {
    if (insertionData[property]) {
      acc[property] = insertionData[property]
    }
    return acc
  }, {} as ApiSearchDataPartial)
}

export const noApiSearchDataToApi = (_insertionData: ContentStateInterface): ApiSearchDataPartial | undefined =>
  undefined

export type ApiSearchDataToApiMapper = typeof apiSearchDataToApi
